/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const START_PLAYERS_MATCHING = (
    <FormattedMessage
        id='players_matching.start'
        defaultMessage='В бой!'
    />
)

export const VEHICLES_NOT_READY = (
    <FormattedMessage
        id='players_matching.vehicles_not_ready'
        defaultMessage='Выбранная техника не готова к бою'
    />
)

export const VEHICLES_NOT_SELECTED = (
    <FormattedMessage
        id='players_matching.vehicles_not_selected'
        defaultMessage='Выберите технику, на которой собираетесь выйти в бой'
    />
)

export const GO_TO_ANOTHER_SERVER = peripheryNames => (
    <FormattedMessage
        id="players_matching.go_to_another_server"
        defaultMessage="Перейдите на сервер {peripheryNames}"
        values={{ peripheryNames }}
    />
)

export const AVAILABLE_INTERIM_BEFORE_PRIME = minutes => (
    <FormattedMessage
        id="players_matching.available_interim_before_prime"
        defaultMessage="Начать подбор отряда можно за {minutes} мин. до начала сражений"
        values={{ minutes }}
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/translations.js